export default __webpack_public_path__ + "static/media/personal-points-lists.4443b462.png";